/*
 * Copyright (c) 2024.
 * The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 *
 */

import {PaymentStatus} from "types/enums/PaymentStatus";
import {Payment} from "types/entities/Payment";
import {PaymentAssert, SaferPayErrorNames} from "store/booking/BookingAction";

export const isResultSuccess = (payment: Payment | null) => {
    if (!payment) {
        return false;
    }
    const status: PaymentStatus = payment.status as PaymentStatus;
    switch (status) {
        case PaymentStatus.Finished:
        case PaymentStatus.Authorized:
        case PaymentStatus.Captured:
            return true;
        case PaymentStatus.Started:
        case PaymentStatus.Canceled:
        case PaymentStatus.Aborted:
            return false;
        default:
            return false;
    }
};

export const isAssertSuccess = (paymentAssert: PaymentAssert | null) => {
    if (!paymentAssert) {
        return false;
    }
    const errorName: SaferPayErrorNames = paymentAssert.ErrorName;
    switch (errorName) {
        default:
            return false;
    }
};
